import Vue from 'vue'
import axios from 'axios'
import https from 'https'
import store from '../store'
import route from '../router'

const jwtDecode = require('jwt-decode')

export const AXIOS = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: false,
  httpsAgent: new https.Agent({ keepAlive: true })
})

AXIOS.interceptors.request.use((config) => {
  const tokenFromCookie = Vue.$cookies.get('KC-TOKEN')
  if (tokenFromCookie != null) {
    const tokenFromState = store.getters['authentication/token']
    if (tokenFromCookie !== tokenFromState) {
      store.commit('authentication/setLoginSuccess', tokenFromCookie)
      route.go()
    }
  } else {
    store.commit('authentication/setAuthenticationExpired')
  }

  // get token from state et check is validity
  const tokenToValidate = store.getters['authentication/token']
  if (!isTokenValid(tokenToValidate)) {
    store.commit('authentication/setAuthenticationExpired')
  }

  config.headers.Authorization = 'Bearer '.concat(tokenToValidate)
  config.headers.orgaid = store.getters['authentication/orgaId']
  return config
})

AXIOS.interceptors.response.use(
  response => {
    if (response.status >= 200 && response.status < 400) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    const code = parseInt(error.response && error.response.status)
    if (code === 401) {
      store.commit('authentication/set401Error', error)
      return
    } else if (code === 403) {
      store.commit('authentication/set403Error', error)
      return
    }

    if (error.message === 'Network Error') {
      store.commit('authentication/set401Error', error)
      return
    }

    return Promise.reject(error)
  }
)

function isTokenValid (token) {
  const decodedToken = jwtDecode(token)
  return decodedToken && (decodedToken.exp * 1000) > new Date().getTime()
}

export default AXIOS
